import { bundleHandlebarsTemplates } from 'utilities/handlebars';

const templatePathPrefix = '/augmented-reality/templates/';
const context = require.context('./', true, /.html/);
bundleHandlebarsTemplates(context, templatePathPrefix);
